'use strict';

export default class ProgressBar {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.windowHeight = $(window).outerHeight();
    this.totalScrollHeight = $('body').outerHeight();
    this.detailWrapperOffsetTop = $(".detail-wrapper").length ? $(".detail-wrapper").offset().top : 0;
    this.siteFooterHeight = $('.site-footer').outerHeight();
    this.newsletterHeight = $('.newsletter').length ? $('.newsletter').outerHeight() : 0;
    this.exploreSectionHeight = $('.purplebg-section-wrapper').length ? $('.purplebg-section-wrapper').outerHeight() : 0;

    if(selfInit) this.init();
  }

  init() {
    const percentageScrolled = $(window).scrollTop() / (this.totalScrollHeight - this.windowHeight) * 100;
    $('.scroll-progress-bar__progress', this.$selector).css('width', `${percentageScrolled}%`);
  
    let resizeTimer;

    $(window).on('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        this.windowHeight = $(window).outerHeight();
        this.totalScrollHeight = $('body').outerHeight();
        this.detailWrapperOffsetTop = $(".detail-wrapper").offset().top;
        this.siteFooterHeight = $('.site-footer').outerHeight();
        this.exploreSectionHeight = $('.purplebg-section-wrapper').length ? $('.purplebg-section-wrapper').outerHeight() : 0;
        
        const percentageScrolled = $(window).scrollTop() / (this.totalScrollHeight - this.siteFooterHeight - this.exploreSectionHeight - this.newsletterHeight - this.windowHeight) * 100;
        
        $('.scroll-progress-bar__progress', this.$selector).css('width', `${percentageScrolled}%`);
      }, 300);
    });

    $(window).on('load scroll', () => {
      const percentageScrolled = $(window).scrollTop() / (this.totalScrollHeight - this.siteFooterHeight - this.exploreSectionHeight - this.newsletterHeight - this.windowHeight) * 100;

      $('.scroll-progress-bar__progress', this.$selector).css('width', `${percentageScrolled}%`);

      if ($(window).scrollTop() >= this.detailWrapperOffsetTop - $(".site-header").outerHeight()) {
        this.$selector.addClass("slide-down");
      } else {
        this.$selector.removeClass("slide-down");
      }
    });
  }
}
